var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11H9C9.26522 11 9.51957 10.8946 9.70711 10.7071C9.89464 10.5196 10 10.2652 10 10V3.5L7.5 1H3C2.73478 1 2.48043 1.10536 2.29289 1.29289C2.10536 1.48043 2 1.73478 2 2V6.75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1V3C7 3.26522 7.10536 3.51957 7.29289 3.70711C7.48043 3.89464 7.73478 4 8 4H10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68899 7.81301C6.78761 7.71439 6.86584 7.59731 6.91922 7.46845C6.97259 7.33959 7.00006 7.20149 7.00006 7.06201C7.00006 6.92254 6.97259 6.78443 6.91922 6.65558C6.86584 6.52672 6.78761 6.40964 6.68899 6.31101C6.59037 6.21239 6.47328 6.13416 6.34443 6.08078C6.21557 6.02741 6.07746 5.99994 5.93799 5.99994C5.79851 5.99994 5.66041 6.02741 5.53155 6.08078C5.40269 6.13416 5.28561 6.21239 5.18699 6.31101L2.68199 8.81701C2.56311 8.93582 2.4761 9.08268 2.42899 9.24401L2.01049 10.679C1.99794 10.722 1.99719 10.7676 2.00831 10.8111C2.01943 10.8545 2.04202 10.8941 2.07371 10.9258C2.1054 10.9575 2.14503 10.9801 2.18844 10.9912C2.23186 11.0023 2.27746 11.0016 2.32049 10.989L3.75549 10.5705C3.91682 10.5234 4.06368 10.4364 4.18249 10.3175L6.68899 7.81301Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEdit);
export default __webpack_public_path__ + "static/media/file-edit.5cfdbde515c69006345294846e4906ef.svg";
export { ForwardRef as ReactComponent };